import React, { useState, useEffect, useRef } from 'react';

const ScrollReveal = ({ children, className = "", delay = 0, width = "100%" }) => {
  const [isVisible, setIsVisible] = useState(false);
  const domRef = useRef();

  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) {
        setIsVisible(true);
        observer.unobserve(domRef.current);
      }
    }, { threshold: 0.1, rootMargin: '50px' });

    const currentRef = domRef.current;
    if (currentRef) observer.observe(currentRef);

    return () => {
      if (currentRef) observer.unobserve(currentRef);
    };
  }, []);

  return (
    <div
      ref={domRef}
      className={`reveal-base ${isVisible ? 'reveal-active' : ''} ${className}`}
      style={{ transitionDelay: `${delay}ms`, width }}
    >
      {children}
    </div>
  );
};

export default ScrollReveal;